/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import {
  TRANSACTION_STATUS_PAID,
  TRANSACTION_STATUS_PENDING,
  TRANSACTION_STATUS_UNPAID
} from '../../enums/TransactionStatusCodes.mjs'
import Filter, { FilterableProps } from '../Filter'
import { handleChangeEvent } from '../../../../client/js/lib/form'
import { Checkbox, Radio } from '@mantine/core'
import useArrayFilter from '../../../../client/js/hooks/useArrayFilter'

function TransactionStatusFilter (props: FilterableProps<string[]>) {
  const { onChange, value } = props
  const intl = useIntl()
  const [array, handleChange] = useArrayFilter(value, onChange)
  return (
    <Filter>
      <Radio
        checked={array.length === 0}
        id="transaction_status_all_filter"
        label={intl.formatMessage({
          id: 'all',
          defaultMessage: 'Tout'
        })}
        name="status"
        onChange={handleChangeEvent(onChange)}
        value=""
      />
      <Checkbox
        checked={array.includes(TRANSACTION_STATUS_PENDING)}
        id="transaction_status_pending_filter"
        label={intl.formatMessage({
          id: 'pending',
          defaultMessage: 'En attente'
        })}
        name="status"
        onChange={handleChange}
        value={TRANSACTION_STATUS_PENDING}
      />
      <Checkbox
        checked={array.includes(TRANSACTION_STATUS_UNPAID)}
        id="transaction_status_unpaid_filter"
        label={intl.formatMessage({
          id: 'unpaid',
          defaultMessage: 'Impayé'
        })}
        name="status"
        onChange={handleChange}
        value={TRANSACTION_STATUS_UNPAID}
      />
      <Checkbox
        checked={array.includes(TRANSACTION_STATUS_PAID)}
        id="transaction_status_paid_filter"
        label={intl.formatMessage({
          id: 'paid',
          defaultMessage: 'Payé'
        })}
        name="status"
        onChange={handleChange}
        value={TRANSACTION_STATUS_PAID}
      />
    </Filter>
  )
}

export default TransactionStatusFilter
